import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

const Required = ({ required }) => <span style={{ color: 'red!important', display: required ? 'inline-block' : 'none', fontSize: 10 }}><sup><Icon name="asterisk" color="red" /></sup></span>;

Required.propTypes = {
  required: PropTypes.bool,
};

export default Required;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/Required/index.js